import { SVGProps } from 'react';
const SvgListRemove = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M3 17h7M15 16h6M3 12h11M3 7h11"
    />
  </svg>
);
export default SvgListRemove;
